/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {InfoIcon} from '@ion/dls/src/icons/InfoIcon';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';

const tooltip = makeStyles(theme => ({
  arrow : {
    color : dlsColor('grey1')
  },
  tooltip : {
    ...dlsAlt('components', 'iconTooltip'),
    fontSize  : '12px !important',
    textAlign : 'left !important'
  },
  align : {
    display    : 'flex',
    alignItems : 'center'
  }
}));

// defines the tooltip props ...
export type AccountTooltipProps = {
  title: string | ReactNode;
  align?: boolean;
};

/**
 * The AccountTooltip provides the tooltip on hover of Info Icon.
 * ```typescript
 *   import {AccountTooltip} from '@ion/dls/src/components/buttons';
 *
 *   <AccountTooltip title={title} />
 * ```
 */
export const AccountTooltip = ({title, align}: AccountTooltipProps) => {
  const classes = tooltip();
  
  return (
    <Tooltip title={title} arrow>
      <span className={align ? classes.align : null}>
        <InfoIcon />
      </span>
    </Tooltip>
  );
};

export default React.memo(AccountTooltip);
